import { Country } from 'domain/constances/country';
import { NavBarMenuItem } from 'presentation/components';
import Routes from 'presentation/routes';

export const MenuItemList: NavBarMenuItem[] = [
  { title: 'Inicio', url: Routes.root, country: Country.NI },
  { title: 'Inicio', url: Routes.root, country: Country.GT },
  { title: 'Nosotros', url: Routes.aboutus, country: Country.NI },
  { title: 'Nosotros', url: Routes.aboutus, country: Country.GT },
  { title: 'Comercios Afiliados', url: Routes.affiliated, country: Country.NI },
  { title: 'Comercios Afiliados', url: Routes.affiliated, country: Country.GT },
  { title: 'Centro de Capacitación', url: Routes.capacitacionLanding, country: Country.NI },
  { title: 'Centro de Capacitación', url: Routes.capacitacionLanding, country: Country.GT },
  { title: 'Linea Revolvente y Tarjeta Privada', url: Routes.LineaRevolventeyTarjetaPrivada, country: Country.NI },
  { title: 'Linea Revolvente y Tarjeta Privada', url: Routes.LineaRevolventeyTarjetaPrivada, country: Country.GT },
  { title: 'Tarjeta de Credito Mastercard', url: Routes.tarjetadeCreditoMastercard, country: Country.NI },
  { title: 'Tarjeta de Credito Mastercard', url: Routes.tarjetadeCreditoMastercard, country: Country.GT },
  { title: 'Puntos de Pago', url: Routes.paymentPoints, country: Country.GT },
  {
    title: 'Servicio al Cliente',
    url: Routes.customerService,
    country: Country.NI,
  },
  { title: 'Programa de Lealtad', url: Routes.loyaltyProgram, country: Country.NI  },
  { title: 'Descargá ZüApp', url: Routes.downloadApp, country: Country.NI },
  {
    title: 'Servicio al Cliente',
    url: Routes.customerService,
    country: Country.GT,
  },
  { title: 'Factoring', url: Routes.factoring, country: Country.NI },
  { title: 'Inversiones', url: Routes.inversiones, country: Country.NI },
  {
    title: 'Efectivo de inmediato',
    url: Routes.instantCash,
    country: Country.GT,
  },
];

export const AuthenticatedUserMenuItems: NavBarMenuItem[] = [
  { title: 'Mi Cuenta', url: Routes.dashboard, country: Country.NI },
  { title: 'Mi Cuenta', url: Routes.dashboard, country: Country.GT },
];
